<template>
  <div class="alert" :class="[`alert-${type}`]" role="alert">
    <h3 v-if="title">{{ title }}</h3>
    <template v-if="typeof message == 'string'">
      <p v-html="message" />
    </template>
    <template v-else>
      <pre>{{ message }}</pre>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "info",
    },
    title: {
      type: String,
      default: "",
    },
    message: {
      type: [String, Array, Object],
      default() {
        return "";
      },
    },
  },
};
</script>

<style>
</style>